import api from '@/api/tecnologico.api'

let servicio = {}

servicio.planesCon = (idSistema) => {
    return api.get(`/planes/planescon/${idSistema}`)
}

servicio.planesConCaracteristicasCon = (idSistema) => {
    return api.get(`/planes/planesconcaracteristicascon/${idSistema}`)
}

servicio.guardar = (data) => {
    return api.post('/planes/guardarplan', data)
}

servicio.cambiarEstatus = (data) => {
    return api.post('/planes/cambiarestatusplan', data)
}

export default servicio
